import { render, staticRenderFns } from "./CalcShell.vue?vue&type=template&id=13e56c5a&scoped=true"
import script from "./CalcShell.vue?vue&type=script&lang=js"
export * from "./CalcShell.vue?vue&type=script&lang=js"
import style0 from "./CalcShell.vue?vue&type=style&index=0&id=13e56c5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e56c5a",
  null
  
)

export default component.exports